import { render, staticRenderFns } from "./PolicyAcceptanceDialog.vue?vue&type=template&id=aca4586c&scoped=true"
import script from "./PolicyAcceptanceDialog.vue?vue&type=script&lang=js"
export * from "./PolicyAcceptanceDialog.vue?vue&type=script&lang=js"
import style0 from "./PolicyAcceptanceDialog.vue?vue&type=style&index=0&id=aca4586c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca4586c",
  null
  
)

export default component.exports